@let isLoadingState = isLoading();

<div class="flex flex-col gap-0.5">
  <div class="flex items-center gap-3 min-w-0 min-h-6">
    <span [class]="nameTextClass()">
      {{ ctaResult().name }}
      <span class="italic"> ({{ matchingLabelKey() | translate }}) </span>
    </span>

    @if (isSelected() && actionsVisible()) {
      @if (!isLoadingState) {
        <button
          mat-icon-button
          #menuTrigger="matMenuTrigger"
          type="button"
          [disabled]="store.loading$()"
          [matMenuTriggerFor]="menu"
          [attr.aria-label]="'shared.edit' | translate"
          (click)="$event.stopPropagation()"
        >
          @if (store.loading$()) {
            <app-dots-spinner [absoluteCentered]="true" />
          } @else {
            <app-icon src="icons/edit.svg" [size]="16" />
          }
        </button>

        <mat-menu #menu="matMenu">
          @if (!store.loading$()) {
            @for (item of menuOptions(); track item.action) {
              <button mat-menu-item (click)="onMenuClick(item.action, $event, menuTrigger)">
                {{ item.label | translate }}
              </button>
            }
          }
        </mat-menu>
      } @else {
        <ngx-skeleton-loader class="h-6" [theme]="{ width: '24px', height: '24px', 'border-radius': '100vw' }" />
      }
    }

    @if (!isSelected()) {
      @if (hasStatusIndicatorIssues()) {
        <div class="inline-flex">
          <button
            type="button"
            class="flex items-center"
            [floatUi]="statusPopover"
            [showTrigger]="floatUiTriggerHover"
            [placement]="floatUiPlacement"
            [hideOnClickOutside]="true"
            (click)="$event.stopPropagation()"
          >
            <app-icon src="icons/warning.svg" [size]="16" [color]="statusIconColor()" />
          </button>

          <float-ui-content #statusPopover class="z-50">
            @let kpiStatus = ctaResult().ctaKpiStatus;
            <div class="flex flex-col gap-1 text-xs pl-2 pr-3 py-1 w-max">
              @if (kpiStatus.currentFailedDeliverables > 0) {
                <div class="flex items-center gap-3">
                  <span class="w-3 h-3 rounded-full flex items-center justify-center bg-shikenso-error-bright shrink-0">
                    <app-icon src="icons/close.svg" alt="Failed" color="white" [size]="10" />
                  </span>
                  <span>
                    {{ 'shared.tile.failedDeliverables' | translate: { count: kpiStatus.currentFailedDeliverables } }}
                  </span>
                </div>
              }

              @if (kpiStatus.currentProblemDeliverables > 0) {
                <div class="flex items-center gap-3">
                  <span class="w-3 h-3 rounded-full flex items-center justify-center bg-shikenso-warning-base shrink-0">
                    <app-icon src="icons/backslash.svg" alt="Problem" color="white" [size]="10" />
                  </span>
                  <span>
                    {{
                      'shared.tile.problematicDeliverables' | translate: { count: kpiStatus.currentProblemDeliverables }
                    }}
                  </span>
                </div>
              }

              @if (kpiStatus.currentProblemKpis > 0) {
                <div class="flex items-center gap-3">
                  <span class="w-3 h-3 rounded-full flex items-center justify-center bg-shikenso-warning-base shrink-0">
                    <app-icon src="icons/backslash.svg" alt="KPI Below" color="white" [size]="10" />
                  </span>
                  <span>
                    {{ 'shared.tile.kpiBelow' | translate: { count: kpiStatus.currentProblemKpis } }}
                  </span>
                </div>
              }

              @if (kpiStatus.currentFailedKpis > 0) {
                <div class="flex items-center gap-3">
                  <span class="w-3 h-3 rounded-full flex items-center justify-center bg-shikenso-error-base shrink-0">
                    <app-icon src="icons/close.svg" alt="KPI Failed" color="white" [size]="10" />
                  </span>
                  <span>
                    {{ 'shared.tile.kpiFailed' | translate: { count: kpiStatus.currentFailedKpis } }}
                  </span>
                </div>
              }
            </div>
          </float-ui-content>
        </div>
      }

      <button
        mat-flat-button
        type="button"
        color="secondary-gray-border"
        class="!px-3 !min-w-fit mat-micro-button"
        (click)="onShowClick()"
      >
        <span class="text-[10px]"> {{ 'shared.show' | translate }} </span>
      </button>
    }
  </div>

  @if (subheaderVisible()) {
    @if (isLoadingState) {
      <ngx-skeleton-loader
        [class]="textSize() === 'sm' ? 'h-4' : 'h-[15px]'"
        [theme]="{
          width: textSize() === 'sm' ? '140px' : '120px',
          height: textSize() === 'sm' ? '16px' : '15px',
          'border-radius': '4px',
        }"
      />
    } @else {
      <span [class]="subheaderTextClass() + ' text-shikenso-purple-base-60'">
        {{ subheaderKey() | translate }}
      </span>
    }
  }
</div>
